import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcpSearchComponent } from './fcp-search.component';
import { FcpIconModule } from '../fcp-icon';
import { FcpInputModule } from '../fcp-input';
import { FcpButtonModule } from '../fcp-button';

@NgModule({
    declarations: [FcpSearchComponent],
    exports: [FcpSearchComponent],
    imports: [CommonModule, FcpIconModule, FcpInputModule, FcpButtonModule]
})
export class FcpSearchModule {}
